/**
 * Routes of area (d) — communication. OWNED BY area (d) — communication: tighten `validateSearch`, add loaders, swap `component`
 * for the real screen (keep the paths — boards.ts hrefs point at them). Generated by the foundation.
 */
import { createRoute } from "@tanstack/react-router";
import { z } from "zod";
import { boardsAt } from "@/boards/board-switch";
import { guard, looseSearch, staffRoute } from "@/app/route-base";

/** Admin-Discussions */
export const comptaDiscussionsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/compta/discussions",
  // « Discussions » from a client file: the list is limited to that company (pill « Client : {nom} »);
  // `?nouveau=1` opens « Nouveau fil » (prefilled with that company).
  validateSearch: z.object({
    entrepriseId: z.string().min(1).optional().catch(undefined),
    fil: z.string().min(1).optional().catch(undefined),
    nouveau: z.coerce.number().int().min(1).max(1).optional().catch(undefined),
  }),
  beforeLoad: guard("discussions", "read"),
  component: boardsAt("/compta/discussions"),
});

/** Admin-Messagerie */
export const messagerieRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/messagerie",
  validateSearch: looseSearch,
  beforeLoad: guard("discussions", "read"),
  component: boardsAt("/messagerie"),
});

/** Admin-RendezVous */
export const rendezVousRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/rendez-vous",
  validateSearch: looseSearch,
  beforeLoad: guard("bookings", "read"),
  component: boardsAt("/rendez-vous"),
});

/** Admin-Disponibilites */
export const parametresDisponibilitesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres/disponibilites",
  validateSearch: looseSearch,
  beforeLoad: guard("bookings", "read"),
  component: boardsAt("/parametres/disponibilites"),
});

/** Admin-Parametres-Profil */
export const parametresRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres",
  validateSearch: looseSearch,
  beforeLoad: guard("settings.personal", "read"),
  component: boardsAt("/parametres"),
});

/** Admin-Parametres-Modeles */
export const parametresModelesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres/modeles",
  validateSearch: looseSearch,
  beforeLoad: guard("settings.firm", "read"),
  component: boardsAt("/parametres/modeles"),
});

/** Admin-Parametres-Forfait */
export const parametresForfaitRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres/forfait",
  validateSearch: looseSearch,
  beforeLoad: guard("settings.firm", "read"),
  component: boardsAt("/parametres/forfait"),
});

/** Admin-Parametres-Integrations */
export const parametresIntegrationsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres/integrations",
  validateSearch: looseSearch,
  beforeLoad: guard("settings.firm", "read"),
  component: boardsAt("/parametres/integrations"),
});

/** Admin-Parametres-Notifications */
export const parametresNotificationsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/parametres/notifications",
  validateSearch: looseSearch,
  beforeLoad: guard("settings.personal", "read"),
  component: boardsAt("/parametres/notifications"),
});

export const communicationRoutes = [comptaDiscussionsRoute, messagerieRoute, rendezVousRoute, parametresDisponibilitesRoute, parametresRoute, parametresModelesRoute, parametresForfaitRoute, parametresIntegrationsRoute, parametresNotificationsRoute] as const;
